<template>
  <div>
    <div class="sampleWrap">
        <h3>기본 selectBox</h3>
        <!-- ------------ -->
        <base-selectbox selectName="SelectBox 버튼 미포함"
            :default="''" 
            :valName="'sample1'"
            :only="false"
            v-on:selectSearch="sample2"
            :survey="false"
            :surveyIdx="'aaa'"
            v-on:surveyVal="sample3"
            :options="[{text:'KED-I',value:'aaaa'},{text:'KED-S',value:'a---a'},{text:'AI ELT',value:'ccc'}]"
        ></base-selectbox>
    </div>
    
    <div class="sampleWrap">
        <h3>기본 selectBox 버튼 포함</h3>
        <!-- ------------ -->
        <base-selectbox selectName="SelectBox 버튼 포함"
            :default="''" 
            :valName="'sample'"
            v-on:selectSearch="sampleSearch"
            :options="[{text:'KED-I',value:'aaaa'},{text:'KED-S',value:'a---a'},{text:'AI ELT',value:'ccc'},{text:'AI ELT',value:'ccc'},{text:'AI ELT',value:'ccc'}]"
        ></base-selectbox>
    </div>

    <div class="sampleWrap">
        <h3>검색 영역내 정렬 selectBox</h3>
        <!-- ------------ -->
        <div class="search">
            <!-- 여기 내용만 사용 -->
            <base-sort selectName="정렬선택"
                :valName="'align'"                
                :options="[{text:'최근 변경순',value:'aa'},{text:'계약 만료일순',value:'bb'},{text:'진단서비스 예정순',value:'cc'}]" 
            ></base-sort>
            <!-- 여기 내용만 사용 -->
        </div>
    </div>

    <div class="sampleWrap">
        <h3>검색 영역내 부가기능 selectBox</h3>
        <!-- ------------ -->
        <div class="search">
            <base-selectmenu selectName="부가기능"
                v-on:addOn="go"
                :valName="'add'"
                :options="[{text:'선택대상 문자 보내기',value:'sms'},{text:'목록 저장하기',value:'saveList'},{text:'저장 목록 보기',value:'listView'},{text:'PDF로 보기',value:'pdfView'}]" 
            ></base-selectmenu>
        </div>
    </div>

    <div class="sampleWrap">
        <h3>툴팁</h3>
        <!-- ------------ -->
        <base-tooltip tipTxt="미가동 0원, 가동(1원 ↑), 실동(500만 ↑)"></base-tooltip>
    </div>

  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    sample2: function(data){ // SelectBox 버튼 포함
        console.log('1',data)
    },
    sample3: function(data){ // SelectBox 버튼 포함
        console.log('2',data)
    },
    sampleSearch: function(data){ // SelectBox 버튼 포함
        console.log(data)
    },
    alignSample: function(data){ // 정렬 SelectBox :필요시 사용 attr 추가 : [v-on:sortVal="alignSample"]
        console.log(data)
    },
    go: function(data) { // 부가기능
        if(data == 'sms'){ // 문자 보내기
            console.log('문자 보내기')
        }else if(data == 'saveList'){ // 목록 저장하기
            this.saveList = true;
        }else if(data == 'listView'){ // 저장 목록보기
        this.listView = true;
        }else if(data == 'pdfView'){ // PDF로 보기
            console.log('PDF로 보기')
        }
    },
  },
};
</script>

<style>
.sampleWrap {padding: 20px;}
.sampleWrap h3 {margin-bottom: 10px;padding-bottom: 10px;font-weight: 500;font-size: 16px;border-bottom: 1px solid #000;}
</style>
